// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


(function(){

	const menuItems = document.querySelectorAll('.privary-navigation .privary-navigation__item > a');
	
	menuItems.forEach((item) => {
		if(screen.width > 849) {
			item.addEventListener('mouseenter', function (e) {
				const from = e.relatedTarget;
				if (from && this.parentElement.contains(from)) {
					return;
				}
				if (from && from.closest('.submenu')) {
					return;
				}
				menuItems.forEach(el => el.parentElement.classList.remove("clicked"));
				if (this.nextElementSibling && this.nextElementSibling.classList.contains('submenu')) {
					e.preventDefault();
					this.parentElement.classList.add('clicked');
				}
			});
		} else {
			item.addEventListener('click', function (e) {
				if (this.nextElementSibling.classList.contains('submenu')) {
					e.preventDefault();
					menuItems.forEach(el => el.parentElement.classList.remove("clicked"));
					this.parentElement.classList.add('clicked');
				}
			});
		}
	});
	
	if(screen.width > 849) {
		document.getElementById('header').addEventListener('mouseleave', () => {
			menuItems.forEach(el => el.parentElement.classList.remove("clicked"));
		});
	}

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	//burger menu 
	const burgerMenuBtn = document.querySelector('[data-burgeropen]');
	const burgerMenuClose = document.querySelector('[data-burgerclose]');
	const burgerMenu = document.querySelector('[data-burgermenu]');
	const burgerMenuItems = burgerMenu.querySelectorAll('ul li a');

	if(burgerMenuBtn) {
		burgerMenuBtn.addEventListener('click', (e) =>{
			e.preventDefault();
			burgerMenu.classList.add('open');
			document.body.classList.add('no-scroll');
		});
	}
	if(burgerMenuClose) {
		burgerMenuClose.addEventListener('click', (e) =>{
			e.preventDefault();
			burgerMenu.classList.remove('open');
			document.body.classList.remove('no-scroll');
		});
	}
	if(burgerMenuItems) {
		burgerMenuItems.forEach(el => el.setAttribute('tabindex', '-1'));
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}